export const defaultValues = () => [
  {
    type: "area",
    id: "01",
    value: "63, 26, 81, 46",
    disabled: false
  },
  {
    type: "area",
    id: "02",
    value: "63, 50, 81, 70",
    disabled: false
  },
  {
    type: "area",
    id: "03",
    value: "63, 74, 81, 94",
    disabled: false
  },
  {
    type: "area",
    id: "04",
    value: "63, 97, 81, 117",
    disabled: false
  },
  {
    type: "area",
    id: "05",
    value: "63, 120, 81, 141",
    disabled: false
  },
  {
    type: "area",
    id: "06",
    value: "23, 144, 60, 163",
    disabled: false
  },
  {
    type: "area",
    id: "07",
    value: "2, 120, 20, 141",
    disabled: false
  },
  {
    type: "area",
    id: "08",
    value: "2, 97, 20, 117",
    disabled: false
  },
  {
    type: "area",
    id: "09",
    value: "2, 74, 20, 94",
    disabled: false
  },
  {
    type: "area",
    id: "10",
    value: "2, 50, 20, 70",
    disabled: false
  },
  {
    type: "area",
    id: "11",
    value: "2, 26, 20, 46",
    disabled: false
  },
  {
    type: "area",
    id: "12",
    value: "23, 2, 60, 23",
    disabled: false
  }
];
